import { useEffect, useState } from "react";

const MESSAGES = [
  "Pulling in your entity details...",
  "Verifying company information...",
  "Almost ready...",
];

const CYCLE_MS = 2000;

export const ReviewLoader = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % MESSAGES.length);
    }, CYCLE_MS);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="t-flex t-flex-col t-items-center t-gap-3 t-py-12">
      <div className="t-flex t-gap-1.5">
        <span className="t-h-2 t-w-2 t-animate-pulse t-rounded-full t-bg-purple" />
        <span className="t-h-2 t-w-2 t-animate-pulse t-rounded-full t-bg-purple-40 [animation-delay:200ms]" />
        <span className="t-h-2 t-w-2 t-animate-pulse t-rounded-full t-bg-purple-20 [animation-delay:400ms]" />
      </div>
      <div className="t-text-body t-text-text-30">{MESSAGES[index]}</div>
    </div>
  );
};
